import * as immutable from 'immutable';
import { IdynamicFormItem } from '../interfaces/IdynamicFormItem';
import { FORM_ACTIONS } from './form.actions';
import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';
import { IdataBinding } from '@ispm-client/modules/aggregator/interfaces';
import { IdynamicForm } from '@ispm/dynamic-form/interfaces/IdynamicForm';
import {cloneDeep} from "lodash";

export interface IformState {
  configs: immutable.Map<string, IdynamicFormItem[]>;
  dataBindings: immutable.Map<string, IdataBinding[]>;
  configBindings: immutable.Map<string, IdataBinding[]>;
  formConfigurations: immutable.Map<string, IdynamicForm >;
  formControls: immutable.Map<string, any >;
}

const formInitState: IformState = {
  configs: immutable.Map<string, IdynamicFormItem[]>(),
  dataBindings: immutable.Map<string, IdataBinding[]>(),
  configBindings: immutable.Map<string, IdataBinding[]>(),
  formConfigurations: immutable.Map<string, IdynamicForm>(),
  formControls: immutable.Map<string, any>()
};

export function formReducer(state: IformState = formInitState, action: IgenomicsAction): IformState {
  let newState;
  switch (action.type) {
    case FORM_ACTIONS.ADD_FORM:
      newState = Object.assign({ }, state);
      newState.configs = newState.configs.set(action.payload.name, action.payload.inputs);
      return newState;

    case FORM_ACTIONS.ADD_FORMS:
      newState = Object.assign({ }, state);
      action.payload.map(form => {
        if ((form) &&   (!newState.configs.get(form.name))) {
          newState.configs = newState.configs.set(form.name, form.inputs);
          newState.formConfigurations = newState.formConfigurations.set(form.name, form);
          newState.dataBindings = newState.dataBindings.set(form.name, form.dataBinding);
          newState.configBindings = newState.configBindings.set(form.name, form.configBinding);
          newState.formControls = newState.formControls.set(form.name, {});
        }
      });
      return newState;

    case FORM_ACTIONS.REMOVE_FORM:
      newState = Object.assign({ }, state);
      newState.configs = newState.configs.remove(action.payload.name);
      return newState;
    case FORM_ACTIONS.ADD_DATABINDINGS:
      newState = Object.assign({ }, state);
      if (!newState.dataBindings.get(action.payload.name)) {
        newState.dataBindings = newState.dataBindings.set(action.payload.name, action.payload.dataBindings);
      }
      return newState;
    case FORM_ACTIONS.ADD_CONFIG_BINDINGS:
      newState = Object.assign({ }, state);
      if (!newState.configBindings.get(action.payload.name)) {
        newState.configBindings = newState.configBindings.set(action.payload.name, action.payload.configBindings);
      }
      return newState;
    case FORM_ACTIONS.ADD_FORM_PROPS:
      newState = Object.assign({ }, state);
      newState.formConfigurations = newState.formConfigurations.set(action.payload.name, action.payload.form);
      return  newState;
    case FORM_ACTIONS.REMOVE_FORM_PROPS:
      newState = Object.assign({ }, state);
      newState.formConfigurations = newState.formConfigurations.remove(action.payload.name);
      return  newState;
    case FORM_ACTIONS.REMOVE_DATABINDINGS:
      newState = Object.assign({ }, state);
      newState.dataBindings = newState.dataBindings.remove(action.payload.name);
      return newState;
    case FORM_ACTIONS.REMOVE_CONFIG_BINDINGS:
      newState = Object.assign({ }, state);
      newState.configBindings = newState.configBindings.remove(action.payload.name);
      return newState;
    case FORM_ACTIONS.UPDATE_FORM_CONTROLS:
      let formControls = state.formControls.get(action.payload.name) ?? {};
      formControls.controls = cloneDeep(action.payload.controls);
      formControls.formStatus = action.payload.formStatus;
      state.formControls = state.formControls.set(action.payload.name, formControls);
      return { ...state};
    default:
      return state;
  }
}
